/**
 * Common auth mixins
 *
 */
export default {
  data() {
    return {
      popupFestival: window._popupFestival,
      inputLength: window._inputLength
    }
  },
  methods : {
    popupBreath(){
      var VUE = this
      if(this.popupFestival.festival_popup.flag == true){
        $('.fadein').fadeIn();
        setTimeout(function(){
            VUE.closePopup()
        },5000)
      }
    },
    closePopup(){
      $('.fadein').fadeOut();
    },

  }
}



// WEBPACK FOOTER //
// ./resources/mhg/vue/mixins/authCommon.js